import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { PinIcon } from "lucide-react";

import { formatDateAt } from "simplydo/core/dates";
import { groupCoverImage } from "simplydo/core/images";
import { RichTextViewer } from "simplydo/react/richtext";
import { Icon } from "simplydo/react/ui/icon";
import { Label } from "simplydo/react/ui/label";

import { UserChip } from "components/lib/Chips";

import { FeedItemOfType } from "../types";
import {
  FeedItem,
  FeedItemContent,
  FeedItemDate,
  FeedItemIcon,
  FeedItemMessage,
} from "./FeedItemUI";
type GroupActivityFeedPostFeedItemProps = {
  item: FeedItemOfType<"groupActivityFeedPost">;
};

const GroupActivityFeedPostFeedItem = ({
  item,
}: GroupActivityFeedPostFeedItemProps) => {
  const { t } = useTranslation();
  return (
    <FeedItem>
      <div>
        {item.isPinned ? (
          <Label
            color="green"
            circular
            style={{ width: 30, height: 30, marginBottom: 4 }}
          >
            <Icon icon={PinIcon} />
          </Label>
        ) : null}
        <FeedItemIcon src={groupCoverImage(item.ownerGroup)} />
      </div>
      <FeedItemContent>
        <FeedItemMessage>
          <b>
            <UserChip user={item.owner} compact="very" />
          </b>{" "}
          <span>
            posted a message to{" "}
            <Link to={`/groups/${item.ownerGroup?._id}/feed`}>
              {item.ownerGroup?.name || t("groups.activityFeed.thisGroup")}
            </Link>
            .
          </span>
        </FeedItemMessage>
        <RichTextViewer value={item.message} />
        <FeedItemDate>{formatDateAt(item.createdAt)}</FeedItemDate>
      </FeedItemContent>
    </FeedItem>
  );
};

export default GroupActivityFeedPostFeedItem;
